import { Component, computed, input, output, signal } from '@angular/core';

import { CustomTagComponent } from '@shared/components/custom-tag/custom-tag.component';
import {
  PillItem,
  PillsOverflowComponent
} from '@shared/components/pills-overflow/pills-overflow.component';

import { CellOverlayAction } from '../../actions-overlay/actions-overlay.component';

export interface TagCellItem {
  id: string;
  label: string;
  color: string;
}

export function getContrastColor(hex: string): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? '#000000' : '#ffffff';
}

@Component({
  selector: 'app-tag-list-cell',
  imports: [PillsOverflowComponent, CustomTagComponent],
  templateUrl: './tag-list-cell.component.html'
})
export class TagListCellComponent {
  /** A getter so the overlay, which reads it inside a computed, follows `filterable`. */
  get availableCellActions(): CellOverlayAction[] {
    return this.filterable() ? ['copy', 'filter'] : ['copy'];
  }
  availableCellShiftActions: CellOverlayAction[] = [];

  value = input<unknown | undefined>(undefined);
  /** Off where the page cannot filter on tags, so a chip never looks clickable for nothing. */
  filterable = input<boolean>(false);

  uidClick = output<string>();

  private readonly hoveredTagLabel = signal<string | undefined>(undefined);

  protected pillItems = computed<PillItem[]>(() => {
    const items = this.value();
    if (!Array.isArray(items)) return [];
    return (items as TagCellItem[]).map((tag) => ({ id: tag.id, data: tag }));
  });

  protected onPillHover(item: PillItem): void {
    this.hoveredTagLabel.set((item.data as TagCellItem).label);
  }

  protected onPillHoverEnd(): void {
    this.hoveredTagLabel.set(undefined);
  }

  protected onPillClick(item: PillItem): void {
    this.uidClick.emit((item.data as TagCellItem).label);
  }

  filterValue(): string | undefined {
    const items = this.value();
    return this.hoveredTagLabel() ?? (Array.isArray(items) ? items[0]?.label : undefined);
  }
}
